import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';
import { supabase } from '../../lib/supabase';

interface NavigationItem {
  id: string;
  label: string;
  path: string;
  display_order: number;
  is_active: boolean;
}

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [navLinks, setNavLinks] = useState<NavigationItem[]>([]);
  const location = useLocation();

  useEffect(() => {
    async function fetchNavigation() {
      try {
        const { data, error } = await supabase
          .from('navigation_items')
          .select('*')
          .eq('is_active', true)
          .order('display_order', { ascending: true });

        if (error) throw error;
        if (data) setNavLinks(data);
      } catch (error) {
        console.error('Error fetching navigation:', error);
      }
    }

    fetchNavigation();
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-2xl font-bold bg-gradient-to-r from-yellow-600 to-yellow-700 bg-clip-text text-transparent">
              THE 21-DAY BUSINESS WEBSITE™
            </div>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-yellow-700'
                    : 'text-slate-700 hover:text-yellow-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact">
              <Button size="sm">Démarrer mon projet</Button>
            </Link>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.id}
                to={link.path}
                className={`block py-2 text-base font-medium cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-yellow-700'
                    : 'text-slate-700'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button size="sm" className="w-full">Démarrer mon projet</Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
